/*
firebase.js: The file where all the configuration goes that you have seen previously on your
Firebase dashboard. In addition, Firebase itself will be instantiated in this file.
*/

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore"

// firebase project for development only
const devConfig = {
  apiKey: "AIzaSyD23iwDrVj6lVrw2pqPh1EqmkA9Cd7bYCo",
  authDomain: "sms-development.firebaseapp.com",
  databaseURL: "https://sms-development.firebaseio.com",
  projectId: "sms-development",
  storageBucket: "sms-development.appspot.com",
  messagingSenderId: "407509726461"
};

const ProductionConfig = {
  apiKey: "AIzaSyBtPFBbkYmM9rDAK_YYFPFtPP-jd1KSSwk",
  authDomain: "sms-web101.firebaseapp.com",
  databaseURL: "https://sms-web101.firebaseio.com",
  projectId: "sms-web101",
  storageBucket: "sms-web101.appspot.com",
  messagingSenderId: "827212778074"
};

const config =
  process.env.NODE_ENV === "production" ? ProductionConfig : ProductionConfig;

// initialize it, if it isn’t already initialized, with the configuration object.
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();
const firestore = firebase.firestore();

export { auth, db, firestore };
